import { useState } from "react";
import { SectionCard, SectionCardTitle, Slider } from "@/components";
import { slide } from "./consts";

// export const tabs = [
//   { title: "Aquaculture & Poultry India", value: "1" },
// ];

const EmployeeTestemonials = () => {
  const [activeTab, setActiveTab] = useState("1");
  const [expanded, setExpanded] = useState<{ [key: number]: boolean }>({});
  const [isAutoSlide, setIsAutoSlide] = useState(true); // 👈 autoplay control

  const toggleExpand = (index: number) => {
    setExpanded((prev) => {
      const newExpanded = { ...prev, [index]: !prev[index] };

      // If any testimonial is expanded → stop slider
      const hasExpanded = Object.values(newExpanded).some(Boolean);
      setIsAutoSlide(!hasExpanded);

      return newExpanded;
    });
  };

  return (
    <section className="bg-blue-900 lg:pb-[100px] relative">
      <div className="hidden lg:block h-[130px] w-[130px] bg-primary rounded-full absolute bottom-10 right-15 float-animation" />
      <SectionCard className="bg-[url('/img/testimonials_bg.png')] bg-no-repeat bg-left bg-contain flex flex-col items-center justify-center text-white">
        <SectionCardTitle className="lg:w-full mb-6 text-center">
          Employee Testimonials
        </SectionCardTitle>

        {/* Tabs */}
        {/* <div className="flex gap-8 mb-10">
          {tabs.map((tab) => (
            <button
              key={tab.value}
              onClick={() => setActiveTab(tab.value)}
              className={`relative pb-2 text-base font-medium transition-colors cursor-pointer ${
                activeTab === tab.value
                  ? "text-white"
                  : "text-white/60 hover:text-white"
              }`}
            >
              {tab.title}
              <span
                className={`absolute left-0 -bottom-[1px] h-[2px] rounded transition-all duration-300 ${
                  activeTab === tab.value ? "w-full bg-white" : "w-0 bg-transparent"
                }`}
              />
            </button>
          ))}
        </div> */}

        {/* Slider */}
        <Slider
          key={activeTab}
          hideDots
          whiteNextPrevButton
          autoSlide={isAutoSlide} // 👈 controlled autoplay
          slides={slide
            .filter((data: any) => data.category === activeTab)
            .map((data: any, index: number) => {
              const isExpanded = expanded[index] || false;
              const maxChars = 300;
              const shortText =
                data.testimonial.length > maxChars
                  ? data.testimonial.substring(0, maxChars) + "..."
                  : data.testimonial;

              return (
                <div
                  key={index}
                  className="w-full flex-shrink-0 lg:px-[90px] flex items-center justify-center mb-10 mt-10"
                >
                  <div className="bg-[#F7FFFF] rounded-[20px] shadow-lg p-6 lg:p-10 max-w-[1000px] relative flex flex-col text-left">
                      <img
                        src={data.image || "/img/placeholder.jpg"} 
                        alt={data.name || "Employee"}
                        className="w-25 h-25 rounded-full object-cover object-[50%_28%]"
                      />

                    <h3 className="text-2xl font-bold text-[#1D3A63] mb-1">
                      {data.name}
                    </h3>
                    <p className="text-base text-gray-500 mb-6">
                      {data.designation}
                    </p>

                    {/* Testimonial with Read More */}
                    <div className="text-gray-600 text-sm text-justify">
                      <p
                        dangerouslySetInnerHTML={{
                          __html: isExpanded ? data.testimonial : shortText,
                        }}
                      />
                      {data.testimonial.length > maxChars && (
                        <button
                          onClick={() => toggleExpand(index)}
                          className="text-blue-600 mt-2 font-medium cursor-pointer"
                        >
                          {isExpanded ? "Read less" : "Read more"}
                        </button>
                      )}
                    </div>

                    {/* Quote Icon */}
                    <div className="absolute top-6 right-6 text-[#FF9C9C] text-8xl font-serif">
                      &rdquo;
                    </div>
                  </div>
                </div>
              );
            })}
        />
      </SectionCard>
    </section>
  );
};

export default EmployeeTestemonials;
